import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Web3WalletService } from '../../../../../services/web3-wallet.service';
import { ethers } from 'ethers';
import { CreatureWebDto } from '../../../../../dtos/creature.web.dto';
import { MarketplaceTradeListingService } from '../../../../../services/marketplace-trade-listing.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'list-for-sell-creature-popup',
    templateUrl: './list-for-sale-creature.popup.html',
    styleUrl: './list-for-sale-creature.popup.scss',
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule
    ]
})
export class ListForSaleCreaturePopup implements OnInit {

    @Input() show: boolean = false;
    @Output() showChange = new EventEmitter<boolean>();

    @Input()
    public creatureRef!: CreatureWebDto;

    public numberPrecision = 4;
    public marketFeeInPercent = 5;

    public sellPrice: number = 0.001;
    public floorSellPrice: number = 0.001;
    public marketFee: number | null = null;
    public amountToTransferToSeller: number | null = null;

    public durationInDays: number = 100;

    public showLoading: boolean = false;

    constructor(private readonly web3WalletService: Web3WalletService, private readonly marketplaceTradeListingService: MarketplaceTradeListingService) {

    }

    ngOnInit(): void {
        if (this.creatureRef && this.creatureRef.tradeListing) {
            this.sellPrice = this.creatureRef.tradeListing.price;
            this.durationInDays = this.creatureRef.tradeListing.durationInDays;
        }

        this.updateMarketFee(this.sellPrice);
    }

    public onChangePrice($event: Event) {
        const input = $event.target as HTMLInputElement;
        const value = parseFloat(input.value);
        this.updateMarketFee(value);
    }

    private updateMarketFee(value: number) {
        this.marketFee = this.roundToPrecision(value * this.marketFeeInPercent / 100, this.numberPrecision);
        this.amountToTransferToSeller = this.roundToPrecision(value - this.marketFee, this.numberPrecision);

        this.sellPrice = value;
    }

    async onSubmit($event: Event) {
        try {
            this.showLoading = true;

            const adminAddress = this.web3WalletService.getAdminAddress()!;

            const myAddress = this.web3WalletService.getWalletAddress()!;

            const contract: any = await this.web3WalletService.getNftContract();
            const feeData = await this.web3WalletService.getFeeData();
            const gasPriceInWei = ethers.formatUnits(feeData.gasPrice!, 'wei');

            const estimatedGas = await this.web3WalletService.providerRef!.estimateGas({
                to: contract.target,
                from: myAddress,
                data: contract.interface.encodeFunctionData('approve', [adminAddress, this.creatureRef.nftTokenId!]),
            });

            const tx = await contract.approve(adminAddress, this.creatureRef.nftTokenId!, {
                gasPrice: gasPriceInWei,
                gasLimit: estimatedGas
            });

            const receipt = await tx.wait();

            this.marketplaceTradeListingService.create(
                this.creatureRef.id,
                {
                    // nftTokenId: this.creatureRef.nftTokenId!,
                    durationInDays: this.durationInDays,
                    price: this.sellPrice,
                    transactionHash: tx.hash
                }).subscribe({
                    next: (data) => {
                        this.creatureRef.tradeListing = data;
                        this.showLoading = false;
                        this.closePopup();
                    },
                    error: (err) => {
                        console.error('Error creating listing:', err);
                        this.showLoading = false;
                    },
                });
        } catch (error) {
            console.error('Error executing approve function:', error);
            this.showLoading = false;
        }
    }

    async onCancel($event: Event) {
        try {
            this.marketplaceTradeListingService.delete(this.creatureRef.id).subscribe({
                    next: (data) => {
                        this.creatureRef.tradeListing = null;
                        this.showLoading = false;
                        this.closePopup();
                    },
                    error: (err) => {
                        console.error('Error creating listing:', err);
                        this.showLoading = false;
                    },
                });
        } catch (error) {
            console.error('Error executing approve function:', error);
            this.showLoading = false;
        }
    }

    closePopup() {
        this.show = false;
        this.showChange.emit(this.show);
    }

    roundToPrecision(value: number, precision: number): number {
        const factor = Math.pow(10, precision);
        return Math.round(value * factor) / factor;
    }
}
